import { render } from "./AdminCountryCreate.vue?vue&type=template&id=70526882&scoped=true&ts=true&lang=true"
import script from "./AdminCountryCreate.vue?vue&type=script&lang=ts"
export * from "./AdminCountryCreate.vue?vue&type=script&lang=ts"

import "./AdminCountryCreate.vue?vue&type=style&index=0&id=70526882&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70526882"]])

export default __exports__